

import DATAMASTER from '../library/dataMaster'
import UMUM from '../library/umum'

export default {
    data() {
        return {

            form: {
                id: '',
                unit_kerja: '',
                tahun: new Date().getFullYear(),
                nama_file: '',
                keterangan: '',
                file: null,
                file_old: '',
                file_type: ''
            },
            filterku: {
                tahun: '',
                unit_kerja: '',
                instansi: '',
            },

            selected_file: null,
            selected_file_type: '',
            selected_file_name: '',




            list_data: [],

            page_first: 1,
            page_last: 0,
            page_limit: 10,
            cari_value: "",


            mdl_add: false,
            mdl_edit: false,
            mdl_hapus: false,
            btn_add: false,

            DATAMASTER: DATAMASTER,
            UMUM: UMUM,
        }
    },
    methods: {

        previewFile(data) {
            this.selected_file = data.file;
            this.selected_file_type = data.file_type;
            this.selected_file_name = data.nama_file;

            setTimeout(() => {
                window.scrollTo({ behavior: 'smooth', top: document.body.scrollHeight });
            }, 100);
        },
        downloadFile(filename) {
            window.open(this.$store.state.url.URL_APP + 'uploads/' + filename, '_blank');
        },


        getView: function () {
            this.$store.commit("shoWLoading");
            fetch(this.$store.state.url.DATA_DPA + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    page_limit: this.page_limit,
                    instansi: this.filterku.instansi,
                    unit_kerja: this.filterku.unit_kerja,
                    tahun: this.filterku.tahun,
                })
            })
                .then(res => {
                    if (!res.ok) throw new Error("Server Error");
                    return res.json();
                })
                .then(res_data => {
                    this.list_data = res_data.data || [];
                    this.page_last = res_data.jml_data || 0;
                    this.$store.commit("hideLoading");
                })
                .catch(err => {
                    console.error("Fetch Error:", err);
                    this.$store.commit("hideLoading");
                    this.Notify('Gagal memuat data', 'negative', 'warning');
                });
        },


        addData: function () {

            let fd = new FormData();
            fd.append('form', JSON.stringify(this.form));
            fd.append('file', this.form.file);

            fetch(this.$store.state.url.DATA_DPA + "addData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: fd
            })
                .then(res => res.json())
                .then(res_data => {
                    this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                    this.mdl_add = false;
                    this.getView();
                });

        },




        editData: function () {
            this.$store.commit("shoWLoading");
            this.btn_add = true;

            let fd = new FormData();
            fd.append('form', JSON.stringify(this.form));
            // Jika user memilih file baru, masukkan ke FormData
            if (this.form.file) {
                fd.append('file', this.form.file);
            }

            fetch(this.$store.state.url.DATA_DPA + "editData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: fd
            })
                .then(res => res.json())
                .then(res_data => {
                    this.btn_add = false;
                    this.$store.commit("hideLoading");
                    this.Notify('Sukses Memperbarui Data', 'warning', 'check_circle_outline');
                    this.mdl_edit = false;
                    this.getView(); // Refresh list
                })
                .catch(err => {
                    this.btn_add = false;
                    this.$store.commit("hideLoading");
                    console.error(err);
                });
        },

        removeData: function () {
            this.$store.commit("shoWLoading");

            // Mengambil ID dan Nama File dari form yang sudah diisi saat klik tombol hapus di list
            let data_hapus = {
                id: this.form.id,
                file: this.form.file_old
            };

            fetch(this.$store.state.url.DATA_DPA + "hapusData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(data_hapus)
            })
                .then(res => res.json())
                .then(res_data => {
                    this.$store.commit("hideLoading");
                    this.Notify('Data berhasil dihapus', 'negative', 'delete');
                    this.mdl_hapus = false; // Menutup modal
                    this.getView(); // Refresh data di halaman
                })
                .catch(err => {
                    this.$store.commit("hideLoading");
                    console.error(err);
                });
        },

        selectData: function (data) {

            this.form.id = data.id;
            this.form.tahun = data.tahun;
            this.form.nama_file = data.nama_file;
            this.form.keterangan = data.keterangan;
            this.form.unit_kerja = data.unit_kerja;
            this.form.file_old = data.file;
            this.form.file = null;
        },



        // ====================================== CONTOH eDOC ====================================
        async onChangexInstansi() {
            await DATAMASTER.getInstansiAsync("");
            this.onChangexUnitKerja();
        },
        async onChangexUnitKerja() {
            // console.log("yyyyyyyyyyyy");
            var unitkerjax = await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi)
            // console.log("xxxxxxxxxxxxx");
            console.log(unitkerjax[0].id);
            this.filterku.unit_kerja = unitkerjax[0].id
            // console.log("xxxxxxxxxxxxx");
            console.log(this.filterku.unit_kerja);
            this.getView();
        },


        // ====================================== PAGINATE ====================================
        Notify: function (message, positive, icon) {
            this.$q.notify({
                message: message,
                color: positive,
                icon: icon,
                position: 'top',
                timeout: 500,
            })
        },

        cari_data: function () {
            this.page_first = 1;
            this.getView();
        },

        // ====================================== PAGINATE ====================================

    },

    mounted() {

        let profilex = JSON.parse(localStorage.profile);
        let profile = profilex.profile;
        this.form.unit_kerja = profile.unit_kerja;
        this.filterku.instansi = profile.instansi_id;
        // this.filterku.unit_kerja = profile.unit_kerja;

        const d = new Date();
        let year = d.getFullYear();
        this.form.tahun = year;
        this.filterku.tahun = year;

        // console.log(profile)


        DATAMASTER.getTahun();
        //   DATAMASTER.postMasterUrusan('')
        this.onChangexInstansi();
        // this.getView();

    },
}
